import React, { Component } from "react";
import $ from "jquery";

import HeaderHorizontal from "./HeaderHorizontal";
import Footer from "./Footer";
import { createFragmentContainer, graphql } from "react-relay";
import { withRouter } from "react-router-dom";

class Base extends Component {
  componentWillMount() {
    $("body").addClass("layout-h");
  }

  render() {
    return (
      <div className="wrapper">
        {this.props.user && (
          <HeaderHorizontal
            user={this.props.user}
            history={this.props.history}
          />
        )}

        <section style={{ flexGrow: 1 }}>{this.props.children}</section>

        <Footer />
      </div>
    );
  }
}

const BaseFragment = createFragmentContainer(Base, {
  user: graphql`
    fragment BaseHorizontal_user on UserType {
      ...HeaderHorizontal_user
    }
  `,
});

export default withRouter(BaseFragment);



// WEBPACK FOOTER //
// ./src/components/Layout/BaseHorizontal.js